angular.module('shbdeployer.integrations.storidge').controller('StoridgeClusterController', [
  '$q',
  '$scope',
  '$state',
  'Notifications',
  'StoridgeClusterService',
  'StoridgeNodeService',
  'ModalService',
  function ($q, $scope, $state, Notifications, StoridgeClusterService, StoridgeNodeService, ModalService) {
    $scope.state = {
      shutdownInProgress: false,
      rebootInProgress: false,
    };

    $scope.rebootCluster = function () {
      ModalService.confirm({
        title: 'Вы уверены?',
        message: 'Все узлы кластера будут перезагружены. Перезагрузить кластер Storidge?',
        buttons: {
          confirm: {
            label: 'Перезагрузить',
            className: 'btn-danger',
          },
        },
        callback: function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          rebootCluster();
        },
      });
    };

    function rebootCluster() {
      $scope.state.rebootInProgress = true;
      StoridgeClusterService.reboot().finally(function final() {
        $scope.state.rebootInProgress = false;
        Notifications.success('Кластер перезагружен');
        $state.reload();
      });
    }

    $scope.shutdownCluster = function () {
      ModalService.confirm({
        title: 'Вы уверены?',
        message: 'Все узлы кластера будут выключены. Выключить кластер Storidge?',
        buttons: {
          confirm: {
            label: 'Выключить',
            className: 'btn-danger',
          },
        },
        callback: function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          shutdownCluster();
        },
      });
    };

    function shutdownCluster() {
      $scope.state.shutdownInProgress = true;
      StoridgeClusterService.shutdown().finally(function final() {
        $scope.state.shutdownInProgress = false;
        Notifications.success('Кластер выключен');
        $state.go('docker.dashboard');
      });
    }

    function initView() {
      $q.all({
        info: StoridgeClusterService.info(),
        version: StoridgeClusterService.version(),
        nodes: StoridgeNodeService.nodes(),
      })
        .then(function success(data) {
          $scope.clusterInfo = data.info;
          $scope.clusterVersion = data.version;
          $scope.clusterNodes = data.nodes;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о кластере');
        });
    }

    initView();
  },
]);
